import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List } from 'immutable';
import TextField from '@mui/material/TextField';

import store from 'companion-app-components/utils/redux-store';
import { datasetsActions, datasetsSelectors, datasetsTypes } from 'companion-app-components/flux/datasets';
import { profileSelectors } from 'companion-app-components/flux/profile';
import { authSelectors } from 'companion-app-components/flux/auth';
import { featureFlagsSelectors } from 'companion-app-components/flux/feature-flags';

import SettingsItems from 'containers/Settings/ChildPages/SettingsItems';
import SetupPageWebFirst from 'containers/SetupPage/SetupPageWebFirst';
import { mkDatasetItemArray } from '../../utils';

const dataDictionary = List([
  { id: 'name',
    detailsOnly: false,
    type: 'string',
    label: 'Name',
    flex: 2,
    editable: true,
    unique: false,
    component: TextField },
]);

class SettingsDatasets extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      addNew: null,
    };
  }

  addNew = (datasetObject) => {
    this.setState({ addNew: datasetObject.name });
  };

  createNewDataset = (type) => {
    let newDataset = datasetsSelectors.makeNewDataset(store.getState(), this.props.profile);
    newDataset = newDataset.set('platform', type === 'quicken_windows' ? 'QWIN_MWF' : 'QMAC_MWF');
    newDataset = newDataset.set('name', this.state.addNew);
    this.props.dispatchCreateDatasetsAction(newDataset);
    this.setState({ addNew: null });
  };

  render() {
    const { profile, authSession } = this.props;

    if (this.state.addNew) {
      return (
        <SetupPageWebFirst
          profile={profile}
          authSession={authSession}
          defaultTabIsWindows
          onCreateDataset={this.createNewDataset}
        />
      );
    }
    return (
      <SettingsItems
        dataDictionary={dataDictionary}
        items={this.props.datasets}
        mkImmutableItem={datasetsTypes.mkDataset}
        mkItemArray={mkDatasetItemArray}
        getItems={this.props.dispatchGetDatasetsAction}
        deleteItem={this.props.dispatchDeleteDatasetAction}
        createItem={this.addNew}
        updateItem={this.props.dispatchUpdateDatasetAction}
        title="Finances"
        underConstruction={!this.props.financesEnabled}
        titleIconName={'finances'}
      />
    );
  }
}

SettingsDatasets.propTypes = {
  datasets: PropTypes.object,
  dispatchGetDatasetsAction: PropTypes.func,
  dispatchDeleteDatasetAction: PropTypes.func,
  dispatchCreateDatasetsAction: PropTypes.func,
  dispatchUpdateDatasetAction: PropTypes.func,
  financesEnabled: PropTypes.bool,
  profile: PropTypes.object,
  authSession: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    datasets: datasetsSelectors.getDatasetsById(state),
    financesEnabled: featureFlagsSelectors.getFeatureFlags(state).get('finances'),
    profile: profileSelectors.getProfile(state),
    authSession: authSelectors.getAuthSession(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchGetDatasetsAction: () => dispatch(datasetsActions.getDatasets()),
    dispatchCreateDatasetsAction: (data) => dispatch(datasetsActions.createDataset(data)),
    dispatchUpdateDatasetAction: (data) => dispatch(datasetsActions.updateDataset(data)),
    dispatchDeleteDatasetAction: (data) => dispatch(datasetsActions.deleteDataset(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsDatasets);
